import { FormattedMessage } from 'react-intl';

export function ChargePaymentCardMessage({
  displayBrand,
  last4
}: {
  displayBrand: string;
  last4: string;
}) {
  return (
    <FormattedMessage
      id="modules.BuyProduct.SummaryStep.creditCardMessageWithType"
      defaultMessage="We will charge your {creditCardType}, ending with {creditCardMasked}."
      values={{ creditCardType: displayBrand, creditCardMasked: last4 }}
    />
  );
}
